module.exports = __webpack_public_path__ + "media/home/bloomberg-law-ef45b1b5.png";